import { useQuery } from 'react-query'
import { useParams } from 'react-router-dom'
import { showError } from '../../../../../../_metronic/helpers'
import { getPacienteById } from '../../../paciente-management/pacientes-list/core/_requests'
import { useAuth } from '../../../../auth'

/**
 * Paciente da rota (`:pacienteId`) do histórico clínico. Em cache pela chave: o cabeçalho e as
 * seções (prescrições só para médico da instituição do paciente) dividem a mesma requisição.
 */
export const usePacienteHistorico = () => {
  const { pacienteId } = useParams<{ pacienteId: string }>()
  const { currentUser } = useAuth()

  const { data: paciente, isError } = useQuery(
    ['historico-paciente', pacienteId],
    () => getPacienteById(Number(pacienteId)),
    { enabled: Boolean(pacienteId), refetchOnWindowFocus: false, onError: showError }
  )

  // Médico ativo vinculado à instituição do paciente: vê prescrições e baixa o prontuário.
  const isMedico =
    currentUser?.vinculos?.some(
      (v) => v.ativo && v.medico && v.empresa?.id === paciente?.empresa?.id
    ) ?? false

  return { paciente, isError, isMedico, pacienteId: Number(pacienteId) }
}
